import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute, Router } from '@angular/router';

import { CheckClockLoadService } from '../../services/check-clock-load.service';
import { CheckClockService } from '../../services/check-clock.service';
import { PayrollService } from '../../services/payroll.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-display-check-clock',
    templateUrl: './display-check-clock.component.html',
    styleUrls: ['./display-check-clock.component.css', '../../app.component.css']
})

export class DisplayCheckClockComponent implements OnInit, OnDestroy {
    permission: any = {};

    checkClockLoad: any = [];

    id: string;

    gcclSubs: any;
    gpSubs: any;
    gccSubs: any;

    warningModalActions = new EventEmitter<string|MaterializeAction>();
    warningModalParams = [ {
        dismissible: false,
        complete: function() {
            // console.log('Modal : Close');
        }
    } ];

    globalActions = new EventEmitter<string|MaterializeAction>();

    permissions = [];
    permissionsSubs: Subscription;
    paramSub: Subscription;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private checkClockLoadService: CheckClockLoadService,
                private checkClockService: CheckClockService,
                private payrollService: PayrollService,
                private authService: AuthService,
                private permissionService: PermissionService
    ) {

        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, checkClockLoadService.collection);
        });
        this.paramSub = this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.gcclSubs = this.checkClockLoadService.getCheckClockLoad(this.id).subscribe(checkClockLoadObj => {
                this.gcclSubs.unsubscribe();

                this.checkClockLoad = checkClockLoadObj;

                this.checkClockLoad.loadDate = Utils.getDateWhitoutTime(this.checkClockLoad.loadDate);
                this.checkClockLoad.sinceDate = Utils.getDateWhitoutTime(this.checkClockLoad.sinceDate);
                this.checkClockLoad.untilDate = Utils.getDateWhitoutTime(this.checkClockLoad.untilDate);
            });
        });
    }

    ngOnInit() {

    }
    ngOnDestroy(){
        this.paramSub.unsubscribe();
    }

    openWarningModal() {
        if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
        this.warningModalActions.emit({ action: 'modal', params: ['open'] });
    }

    closeWarningModal() {
        this.warningModalActions.emit({ action: 'modal', params: ['close'] });
    }

    deleteCheckClock() {
        const sDate = new Date(this.checkClockLoad.sinceDate + 'T00:00:00');
        const uDate = new Date(this.checkClockLoad.untilDate + 'T00:00:00');

        this.gpSubs = this.payrollService.getPayrolls().subscribe(tempPayrolls => {
            this.gpSubs.unsubscribe();

            let status = false;

            for (const idx in tempPayrolls) {
                let iDate = new Date(tempPayrolls[idx].startDate + 'T00:00:00');
                let eDate = new Date(tempPayrolls[idx].endDate + 'T00:00:00');

                if (iDate <= sDate && sDate <= eDate) {
                    status = true;
                }

                if (iDate <= uDate && uDate <= eDate) {
                    status = true;
                }
            }

            if (status === true) {
                this.globalActions.emit('toast');

                this.closeWarningModal();
            } else {
                this.gccSubs = this.checkClockService.getCheckClocksByLoadId(this.id).subscribe(tempCheckClock => {
                    this.gccSubs.unsubscribe();

                    console.log('Init');

                    let iRecord = 0;
                    let recordsToBatch = [];
                    const batchs = [];

                    for (const idx in tempCheckClock) {
                        iRecord = iRecord + 1;

                        if (iRecord <= 500) {
                            const checkClockJson = {
                                id: tempCheckClock[idx].id$
                            };

                            recordsToBatch.push(checkClockJson);
                        }

                        if (iRecord === 500) {
                            batchs.push(recordsToBatch);

                            recordsToBatch = [];
                            iRecord = 0;
                        }
                    }

                    if (recordsToBatch.length > 0) {
                        batchs.push(recordsToBatch);
                    }

                    let batchCont = 0;

                    const refClass = this;

                    if (batchs.length === 0) {
                        this.deleteCheckClockLoad(this, this.id);
                    } else {
                        batchs.forEach(item => {
                            Promise.resolve(refClass.checkClockService.deleteCheckClockAtomic(item).then(function() {
                            })).then(function() {
                                batchCont = batchCont + 1;
                                console.log(batchCont);

                                if (batchCont === batchs.length) {
                                    console.log('End');

                                    refClass.deleteCheckClockLoad(refClass, refClass.id);
                                }
                            });
                        });
                    }
                });
            }
        });
    }

    deleteCheckClockLoad(refClass, id) {
        console.log(id);

        refClass.checkClockLoadService.delCheckClockLoad(id).then(res => {
            refClass.closeWarningModal();

            refClass.router.navigate(['/check_clock']);
        });
    }

}
